import { Component, OnInit, Input, ElementRef, ViewChild, HostListener, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { swaggerApiService } from "../services/swaggerApi.service";
import { JSGenerateRSAKey } from "../services/JSGenerateRSAKey";
import { ApiModel } from "../classes/api_model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { templateJitUrl } from '@angular/compiler';
import { HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { log } from 'console';
import { ClipboardService } from '../services/clipboard.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TokenStorageService } from '../services/token-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { OAuthClientService } from '../services/oauth-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { url } from 'inspector';

interface LibraryItem {
  _id: string;
  titleKh?: string;
  titleEn?: string;
  titleFr?: string;
  thumbs?: string;
  publishAt?: string;
  linkOnlineCom?: string;
  meun?: boolean;
  pdf?: boolean;
  displayTitle?: string;
  displayYear?: string;
  thumbUrl?: string;
}
interface ELibrary {
  _id: string;
  titleKh?: string;
  titleEn?: string;
  titleFr?: string;

}
@Component({
  selector: 'app-it',
  templateUrl: './it.component.html',
  styleUrls: ['./it.component.css']
})

export class ItComponent implements OnInit {
  sticky: boolean = false;
  stickys: boolean = false;
  scrolltop: any = false;
  show: any = true;
  scrollNumber: any = 0;
  deviceInfo = null;
  isMobile: boolean;
  isTablet: boolean;
  isDesktopDevice: boolean;
  isLoading = false;
  isLoadingLibrary = false;
  fullListELibrary: LibraryItem[] = [];

  // isDeviceService:boolean;

  listOther = [];
  listApp = [];
  tempOther = [];
  listELib = [];
  dataLiType: any = [];
  private originalDataLiType: any = [];
  listVisionandStrategy = [];
  selectedBookId: string = '';

  list1 = [];
  list2 = [];
  year = 'all';
  keySearch = '';
  hasLibraryResults = true;
  // isLoadingLibrary = false;
  profileImage = '';
  readonly defaultProfileImage = 'assets/icon/default-profile.svg';
  userInfo: any = { profile: '' };
  readonly libraryBaseUrl = `${(environment as any).apiBaseUrl || 'https://api.sathachak.com'}/library/`;


  numIndex = 0;
  @Input("lang") currentLanguage: string = "";

  @ViewChild("stickyMenu", { static: false }) menuElement;
  // @ViewChild('menuElement', { static: true }) menuElementRef: ElementRef;
  // menuPosition: number;

  mobile_sidenav = 0; //set margin-top of menu on SM, XS screen size

  shimmerArray = Array(3);
  //UI state for grid or list view
  viewMode: 'grid' | 'list' = 'grid';
  // UI visibility
  isVisible = false;
  // internal
  private readonly appDownloadBannerDismissedKey = 'lcsItAppDownloadBannerDismissed';
  private appDownloadBannerTimer: any = null;
  private readonly appDownloadBannerAutoCloseMs = 10000;
  private readonly libraryPageSize = 24;
  private libraryRequestSeq = 0;
  private programmaticTabIndex: number | null = null;
  currentLibraryPage = 1;
  loadedLibraryPage = 0;
  totalLibraryItems = 0;
  hasMoreLibraryItems = false;
  private restoredPage = 1;
  private visibleLibraryItemLimit = this.libraryPageSize;
  private libraryServerTotalItems: number | null = null;
  private destroy$ = new Subject<void>();

  key: JSGenerateRSAKey;
  // typed convenience
  years: { value: string; label: string }[] = [
    { value: '2026', label: '២០២៦' },
    { value: '2025', label: '២០២៥' },
    { value: '2024', label: '២០២៤' },
    { value: '2023', label: '២០២៣' },
    { value: '2022', label: '២០២២' },
    { value: '2021', label: '២០២១' },
    { value: '2020', label: '២០២០' },

  ];
  constructor(private deviceService: DeviceDetectorService,
    private _swaggerApiService: swaggerApiService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private clipboard: ClipboardService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private tokenStorage: TokenStorageService,
    private dialog: MatDialog,
    private oauthClient: OAuthClientService,
    private router: Router,
    private route: ActivatedRoute,) {

    this.epicFunction();
    // Share icons
    this.matIconRegistry.addSvgIcon(
      'facebook',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/facebook.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'telegram',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/telegram.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'messenger',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/messenger.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'instagram',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/instagram.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'link',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/link.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'globe',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/globe.svg')
    );

  }

  ngOnInit() {

    // load local view mode
    const saved = localStorage.getItem('elibsViewMode');
    if (saved === 'grid' || saved === 'list') {
      this.viewMode = saved;
    }
    if (this.tokenStorage.handleLogoutParam()) {
      this.clearLocalLogoutState();
    }
    this.initUserProfile();
    this.initAppDownloadBanner();
    this.openPendingBookFromQuery();
    this.key = new JSGenerateRSAKey();
    let objIT = new ApiModel();
    this.isLoading = true;
    objIT.public_key = this.key.getPublicKey();
    objIT.modified_date = new Date().toISOString();
    objIT.limit = 100;
    this._swaggerApiService.postELibrary(objIT)
      .subscribe
      (
        data => {
          let objDecrypt = new ApiModel();
          objDecrypt.private_key = this.key.getPrivateKey();
          objDecrypt.encryptedData = data;
          this._swaggerApiService.postDecrypted(objDecrypt)
            .subscribe
            (
              data => {
                console.log('data displayed  == ', data);
                if (data.statusCode == 200 && data.item.length > 0) {
                  data.item.forEach(element => { });
                }
                else if (data.statusCode == 200 && data.item.length <= 0) {
                  //Toast message to users
                  this._snackBar.open("oops! no more records found.", "OK", {
                    duration: 2000
                  });
                }
                else {
                  //Toast message to users
                  this._snackBar.open("Category : " + data.item, "OK", {
                    duration: 2000
                  });
                }
              }, (error: HttpResponse<Response>) => {
                let errorMsg = error['message'];
                this._snackBar.open("E-Library Decrypt Res_Err: " + errorMsg, "OK", {
                  duration: 2000
                });
              }
            )
        }, (error: HttpResponse<Response>) => {
          let errorMsg = error['message'];
          this._snackBar.open("E-Library Res_Err: " + errorMsg, "OK", {
            duration: 2000
          });
        }
      )

    // type libray
    this._swaggerApiService.postELibraryTypes(objIT)
      .subscribe
      (
        data => {
          let objDecrypt = new ApiModel();
          objDecrypt.private_key = this.key.getPrivateKey();
          objDecrypt.encryptedData = data;
          this._swaggerApiService.postDecrypted(objDecrypt)
            .subscribe
            (
              data => {
                //  console.log('data displayed  == ', data);
                if (data.statusCode == 200 && data.item.length > 0) {
                  this.originalDataLiType = data.item;
                  this.applyLibraryFilters();
                  this.isLoading = false;
                }
                else if (data.statusCode == 200 && data.item.length <= 0) {
                  //Toast message to users
                  this._snackBar.open("oops! no more records found.", "OK", {
                    duration: 2000
                  });
                }
                else {
                  //Toast message to users
                  this._snackBar.open("Category : " + data.item, "OK", {
                    duration: 2000
                  });
                }
              }, (error: HttpResponse<Response>) => {
                let errorMsg = error['message'];
                this._snackBar.open("E-Library Decrypt Res_Err: " + errorMsg, "OK", {
                  duration: 2000
                });
              }
            )
        }, (error: HttpResponse<Response>) => {
          let errorMsg = error['message'];
          this._snackBar.open("E-Library Res_Err: " + errorMsg, "OK", {
            duration: 2000
          });
        }
      )
  }

  onYearSelect(event: Event) {
    const value = (event.target as HTMLSelectElement).value;

    this.year = value;
    this.applyLibraryFilters();
  }

  submitSearch() {
    this.keySearch = (this.keySearch || '').trim();
    this.applyLibraryFilters();
  }

  onInputSearch(event: Event) {
    this.keySearch = (event.target as HTMLInputElement).value;
    this.applyLibraryFilters();
  }

  clearSearch() {
    this.keySearch = '';
    this.applyLibraryFilters();
  }

  private applyLibraryFilters(): void {
    const keyword = (this.keySearch || '').trim().toLowerCase();
    const selectedYear = this.year || 'all';
    const source = this.originalDataLiType || [];

    this.dataLiType = source
      .map((group) => {
        const items = (group.item || []).filter((elib) => {
          const matchesYear = selectedYear === 'all' || this.getELibYear(elib) === selectedYear;
          const matchesKeyword = !keyword || this.getELibSearchText(elib).indexOf(keyword) > -1;
          return matchesYear && matchesKeyword;
        });

        return Object.assign({}, group, { item: items });
      })
      .filter((group) => (group.item || []).length > 0);

    this.hasLibraryResults = this.dataLiType.length > 0;
    this.cdr.markForCheck();
  }

  private getELibYear(elib: any): string {
    if (!elib || !elib.publishAt) {
      return '';
    }

    const publishDate = new Date(elib.publishAt);
    if (isNaN(publishDate.getTime())) {
      return '';
    }

    return publishDate.getFullYear().toString();
  }

  private getELibSearchText(elib: any): string {
    if (!elib) {
      return '';
    }

    return [
      elib.title,
      elib.titleKh,
      elib.titleEn,
      elib.titleFr
    ].filter(Boolean).join(' ').toLowerCase();
  }

  ngAfterViewInit() {
    // this.menuPosition = this.menuElement._elementRef.nativeElement.offsetTop;
  }

  openProfile(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isUserAuthenticated()) {
      this.dialog.closeAll();
      this.navigateToProfile();
    } else {
      this.redirectToLogin();
    }
  }


  navigateToProfile(): void {
    const token = this.tokenStorage.getAccessToken();
    if (!token) {
      console.warn('No auth token found');
      this.clearExpiredLogin();
      this.redirectToLogin();
      return;
    }

    window.location.href = this.getSsoDashboardUrl();
  }
  private clearExpiredLogin(): void {
    this.tokenStorage.saveIsUserLogin('false');
    this.tokenStorage.removeUser();
    localStorage.removeItem('token');
    localStorage.removeItem('userProfileImage');
    this.userInfo = { profile: '' };
    this.profileImage = '';
    this.cdr.markForCheck();
    console.warn('Profile token is invalid or expired. Please login again.');
  }
  private redirectToLogin(bookId?: string): void {
    const returnUrl = this.buildCurrentReturnUrl(bookId);
    const callbackUrl = `${window.location.origin}/auth/callback?returnUrl=${encodeURIComponent(returnUrl)}`;
    const loginUrl = new URL(environment.ssoLoginUrl);
    loginUrl.searchParams.set('redirect_uri', callbackUrl);
    window.location.href = loginUrl.toString();
  }

  initUserProfile(): void {
    if (this.tokenStorage.handleLogoutParam()) {
      this.clearLocalLogoutState();
      return;
    }

    if (this.isUserAuthenticated()) {
      const cachedImage = this.tokenStorage.getProfileImage();
      const cachedUser = this.tokenStorage.getUser();
      if (cachedUser) {
        this.userInfo = cachedUser;
      }
      if (cachedImage) {
        this.profileImage = cachedImage;
      } else if (cachedUser && (cachedUser.profile || cachedUser.image || cachedUser.avatar)) {
        this.profileImage = cachedUser.profile || cachedUser.image || cachedUser.avatar;
      }
      this.profileInfo();
    } else {
      this.profileImage = '';
      this.userInfo = { profile: '' };
      this.cdr.markForCheck();
    }
  }

  getProfileImageUrl(): string {
    if (!this.isUserAuthenticated()) {
      return this.defaultProfileImage;
    }

    const profile = (this.profileImage || (this.userInfo && (this.userInfo.profile || this.userInfo.image || this.userInfo.avatar)) || this.tokenStorage.getProfileImage() || '').toString();
    if (!profile) {
      return this.defaultProfileImage;
    }
    if (profile.startsWith('http://') || profile.startsWith('https://')) {
      return profile;
    }
    return this.libraryBaseUrl + profile;
  }

  onProfileImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (image.getAttribute('src') !== this.defaultProfileImage) {
      image.src = this.defaultProfileImage;
    }
  }

  private clearLocalLogoutState(): void {
    this.tokenStorage.clearSession();
    this.profileImage = '';
    this.userInfo = { profile: '' };
    // this.fetchELibrary().catch((err) => this.handleError(err));
    this.cdr.markForCheck();
  }


  private getProfilePayload(response: any): any {
    return response && (response.user || response.data || response.item || response.profileInfo)
      ? (response.user || response.data || response.item || response.profileInfo)
      : response;
  }

  private getSsoDashboardUrl(): string {
    const defaultDashboard = (environment as any).ssoDashboardUrl
      || (environment.ssoLoginUrl ? new URL('/dashboard', environment.ssoLoginUrl).toString() : (environment.readerUrl || 'http://localhost:4300'));

    try {
      const baseUrl = (environment as any).ssoDashboardUrl || environment.ssoLoginUrl;
      const url = new URL('/verifying', baseUrl);
      url.searchParams.set('redirect', '/dashboard');
      url.searchParams.set('post_logout_redirect', `${window.location.origin}/?logout=1`);

      const token = this.tokenStorage.getAccessToken();
      const refreshToken = this.tokenStorage.getRefreshToken();
      const sessionId = this.tokenStorage.getSessionId();
      const userId = this.tokenStorage.getUserId();

      if (token) {
        url.searchParams.set('token', token);
      }
      if (refreshToken) {
        url.searchParams.set('refreshToken', refreshToken);
      }
      if (sessionId) {
        url.searchParams.set('sessionId', sessionId);
      }
      if (userId) {
        url.searchParams.set('userId', userId);
      }

      return url.toString();
    } catch (error) {
      return defaultDashboard;
    }
  }

  profileInfo() {
    this._swaggerApiService.userProfile().subscribe({
      next: (res) => {
        if (res) {
          if (this.isInvalidTokenResponse(res)) {
            this.clearExpiredLogin();
            return;
          }

          const profile = this.getProfilePayload(res);
          this.userInfo = profile;
          const image = profile.profile || profile.image || profile.avatar || '';
          if (image) {
            this.profileImage = image;
            this.tokenStorage.saveProfileImage(image);
          }
          this.tokenStorage.saveIsUserLogin('true');
          this.tokenStorage.saveUser(profile);
          this.cdr.markForCheck();
        }
      },
      error: (err) => {
        if (this.isInvalidTokenResponse(err && (err.error || err)) || (err && (err.status === 401 || err.status === 403))) {
          this.clearExpiredLogin();
          return;
        }

        console.error('profileInfo error', err);
      },
    });
  }

  private isInvalidTokenResponse(response: any): boolean {
    const message = response && response.message ? response.message.toString().toLowerCase() : '';
    return message.indexOf('invalid') !== -1 && message.indexOf('token') !== -1
      || message.indexOf('expired') !== -1 && message.indexOf('token') !== -1;
  }

  private buildCurrentReturnUrl(bookId?: string): string {
    let path = window.location.pathname;
    if (!path || path === '/' || path.includes('http:') || path.includes('/auth/callback')) {
      path = '/contents/1/km';
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (bookId) {
      searchParams.set('openBook', bookId);
    }
    const query = searchParams.toString();
    return path + (query ? '?' + query : '');
  }


  private openPendingBookFromQuery(): void {
    const bookId = this.route.snapshot.queryParams && this.route.snapshot.queryParams.openBook;
    if (!bookId) {
      return;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { openBook: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });

    const readerUrl = this.buildReaderUrl(bookId, this.isUserAuthenticated());
    window.open(readerUrl, '_blank', 'noopener');
  }





  //on scroll event we add sticky class;
  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    this.scrollNumber = windowScroll

    // if( windowScroll >= 120){
    //   this.sticky = true;
    // }
    // else{
    //   this.sticky = false
    //   this.stickys = false
    // }
  }
  //end scroll dock on top

  //function link to iOS,android,desktop,huawei
  openAppStore(appId) {
    let appStore = 'https://apps.apple.com/kh/app/id' + appId;
    window.open(appStore);
  }
  openPlayStore(playId) {
    let playStore = 'https://play.google.com/store/apps/details?id=' + playId;
    window.open(playStore);

    // console.log("this.deviceService: ", playStore)
  }

  appGalleryLink: string = "https://appgallery.huawei.com/app/";

  openappGallery(appGalleryId) {
    // console.log('appGalleryId', appGalleryId);
    if (appGalleryId == "អុីបណ្ណាល័យនៃសត្ថាចក្រ") {
      let appGallery = this.appGalleryLink + "C114371281";
      window.open(appGallery);

    }
    //  else if (appGalleryId == "មរតកយុត្តិធម៌ខ្មែរ") {
    //   let appGallery= this.appGalleryLink + "C107225183";
    //   window.open(appGallery);

    // } else if(appGalleryId == "ប្រវត្តិការណ៍មួយនៃកម្ពុជា") {
    //   let appGallery=  this.appGalleryLink + "C107225231";
    //   window.open(appGallery);

    // } 
    else {//កម្មវិធីបំប្លែងរូបភាពទៅអក្សរ

    }
  }

  openCompendium(comp, appId, playId, appGalleryId) {
    let compLink = comp;

    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();


    let appStore = 'https://apps.apple.com/kh/app/id' + appId;
    let playStore = 'https://play.google.com/store/apps/details?id=' + playId;
    let appGallery = 'https://appgallery.huawei.com/app/' + appGalleryId;

    // console.log("this.deviceService: ", this.deviceService, appGalleryId)

    if (this.isDesktopDevice) {
      if (this.deviceService.os === 'Mac') {
        window.open(appStore);
      } else if (this.deviceService.os === 'Window') {
        window.open(playStore);
      }
    }

    if (this.isMobile) {
      if (this.deviceService.os === 'IOS') {
        window.open(appStore);
      }
      else {
        window.open(playStore);
        window.open(appGallery);
      }
    }

  }



  private isUserAuthenticated(): boolean {
    const token = this.tokenStorage.getAccessToken();
    const login = localStorage.getItem('login');
    return !!token && login !== 'false';
  }

  openLogin(event: Event, elibs: any): void {
    this.openCompendiumOpenPdf(elibs, event);
  }

  openCompendiumOpenPdf(elibs: any, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!elibs || !elibs._id) {
      this._snackBar.open('Book information is missing. Please try again.', 'OK', { duration: 2500 });
      return;
    }

    const readerUrl = this.buildReaderUrl(elibs._id, this.isUserAuthenticated());
    window.open(readerUrl, '_blank', 'noopener');
  }

  private buildReaderUrl(bookId: string, includeAuth = true): string {
    const readerUrl = new URL('/docs/' + encodeURIComponent(bookId) + '/pdf', environment.readerUrl);

    if (includeAuth) {
      const token = this.tokenStorage.getAccessToken();
      const refreshToken = this.tokenStorage.getRefreshToken();
      const sessionId = this.tokenStorage.getSessionId();

      if (token) {
        readerUrl.searchParams.set('token', token);
      }
      if (refreshToken) {
        readerUrl.searchParams.set('refreshToken', refreshToken);
      }
      if (sessionId) {
        readerUrl.searchParams.set('sessionId', sessionId);
      }
    }

    return readerUrl.toString();
  }
  toKhmerNumber(str) {
    var khNumber = str.toString();

    khNumber = khNumber.replace(/0/g, '០')
    khNumber = khNumber.replace(/1/g, '១')
    khNumber = khNumber.replace(/2/g, '២')
    khNumber = khNumber.replace(/3/g, "៣")
    khNumber = khNumber.replace(/4/g, "៤")
    khNumber = khNumber.replace(/5/g, "៥")
    khNumber = khNumber.replace(/6/g, "៦")
    khNumber = khNumber.replace(/7/g, "៧")
    khNumber = khNumber.replace(/8/g, "៨")
    khNumber = khNumber.replace(/9/g, "៩")

    return khNumber
  }

  convertYear(year) {
    let yearStr = year;
    if (this.currentLanguage == 'km') {
      yearStr = this.toKhmerNumber(year);
    }
    return yearStr;
  }

  getELibTitle(elib) {
    if (this.currentLanguage == 'en' && elib && elib.titleEn) {
      return elib.titleEn;
    }

    if (this.currentLanguage == 'fr' && elib && elib.titleFr) {
      return elib.titleFr;
    }

    if (elib && (elib.titleKh || elib.title)) {
      return elib.titleKh || elib.title;
    }

    return '';
  }

  get filteredLibraryItemCount(): number {
    return (this.dataLiType || []).reduce((total, group) => {
      if (!group || group.title === 'កម្មវិធីលើទូរសព្ទ') {
        return total;
      }
      return total + ((group.item || []).length);
    }, 0);
  }


  //ui helper 
  trackByIndex(index: number, item: any): number {
    return index;
  }

  trackByelibsId(_: number, elibs: any) {
    return elibs && elibs._id ? elibs._id : _;
  }

  onLibraryImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (image && image.getAttribute('src') !== 'assets/icon-lcs.webp') {
      image.src = 'assets/icon-lcs.webp';
    }
  }

  setViewMode(mode: 'grid' | 'list') {
    this.viewMode = mode;
    localStorage.setItem('elibsViewMode', mode);
  }

  shareELib(elib) {
    if (!elib || !elib.linkOnlineCom) {
      return;
    }

    const shareData = {
      title: this.getELibTitle(elib),
      url: elib.linkOnlineCom
    };

    if ((navigator as any).share) {
      (navigator as any).share(shareData);
      return;
    }

    if ((navigator as any).clipboard) {
      (navigator as any).clipboard.writeText(elib.linkOnlineCom);
      return;
    }

    window.open(elib.linkOnlineCom);
  }

  closeBanner() {
    sessionStorage.setItem(this.appDownloadBannerDismissedKey, 'true');
    this.hideAppDownloadBanner();
  }
  private initAppDownloadBanner(): void {
    if (this.wasPageReloaded()) {
      sessionStorage.removeItem(this.appDownloadBannerDismissedKey);
    }

    this.isVisible = sessionStorage.getItem(this.appDownloadBannerDismissedKey) !== 'true';

    if (this.isVisible) {
      this.startAppDownloadBannerTimer();
    }
  }
  private startAppDownloadBannerTimer(): void {
    this.clearAppDownloadBannerTimer();
    this.appDownloadBannerTimer = setTimeout(() => {
      this.hideAppDownloadBanner();
    }, this.appDownloadBannerAutoCloseMs);
  }
  private hideAppDownloadBanner(): void {
    this.clearAppDownloadBannerTimer();
    this.isVisible = false;
    this.cdr.markForCheck();
  }
  private clearAppDownloadBannerTimer(): void {
    if (this.appDownloadBannerTimer) {
      clearTimeout(this.appDownloadBannerTimer);
      this.appDownloadBannerTimer = null;
    }
  }
  private wasPageReloaded(): boolean {
    const navigationEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    const navigation = navigationEntries && navigationEntries[0] as PerformanceNavigationTiming;

    if (navigation) {
      return navigation.type === 'reload';
    }

    return performance.navigation && performance.navigation.type === performance.navigation.TYPE_RELOAD;
  }
  ngOnDestroy(): void {
    this.clearAppDownloadBannerTimer();
    this.destroy$.next();
    this.destroy$.complete();
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();

    // console.log(this.deviceInfo);
    // console.log("From Mobile = ",this.isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    // console.log("From Tablet = ",this.isTablet);  // returns if the device us a tablet (iPad etc)
    // console.log("From Desktop = ",this.isDesktopDevice); // returns if the app is running on a Desktop browser.
  }

  goToLibAlbum() {
    var elmnt = document.getElementById("libAlbum");
    elmnt.scrollIntoView();
  }

  //header កម្រងសម្រង់
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  //header ផ្សេង
  handletop() {
    document.body.scrollTop = 1560;
    document.documentElement.scrollTop = 1560;
  }

  shareOnFacebook(eLibId: string) {
    try {
      const currentUrl = new URL(this.buildReaderUrl(eLibId, false));
      currentUrl.searchParams.delete('page');
      const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl.toString())}`;
      this.openShareWindow2(url);
    } catch (err) {
      this.handleError(err);
    }
  }

  shareOnTelegram(eLibId: string) {
    const currentUrl = new URL(this.buildReaderUrl(eLibId, false));
    currentUrl.searchParams.delete('page');
    const url = `https://t.me/share/url?url=${encodeURIComponent(currentUrl.toString())}`;
    this.openShareWindow2(url);
  }

  shareOnMessenger(eLibId: string) {
    const currentUrl = this.buildReaderUrl(eLibId, false);
    this.clipboard.copy(currentUrl);
    this._snackBar.open('Link copied! Paste it in Messenger', 'OK', { duration: 3000 });
    setTimeout(() => this.openShareWindow2('https://www.facebook.com/messages/t/'), 2500);
  }

  shareOnInstagram(eLibId: string) {
    const currentUrl = this.buildReaderUrl(eLibId, false);
    this.clipboard.copy(currentUrl);
    this._snackBar.open('Link copied! Paste it in Instagram', 'OK', { duration: 3000 });
    setTimeout(() => this.openShareWindow2('https://www.instagram.com/'), 2500);
  }
  copyLinkHoldPage(eLibId: string) {
    try {
      const currentUrl = new URL(this.buildReaderUrl(eLibId, false));
      currentUrl.searchParams.delete('page');
      const baseUrl = currentUrl.toString();
      navigator.clipboard.writeText(baseUrl).then(() => this.showCopyAlert());
    } catch (err) {
      console.error('Failed to copy: ', err);
      this._snackBar.open('Failed to copy!', 'Close', { duration: 2000, horizontalPosition: 'center', verticalPosition: 'bottom' });
    }
  }
  private showCopyAlert() {
    this._snackBar.open('Copied!', 'Close', { duration: 2000, horizontalPosition: 'center', verticalPosition: 'bottom' });
  }

  private openShareWindow2(url: string) {
    const left = (screen.width - 570) / 2;
    const top = (screen.height - 570) / 2;
    const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
    window.open(url, '', params);
  }
  // ----- centralized error handling -----
  private handleError(error: any): void {
    this.isLoading = false;
    this.isLoadingLibrary = false;
    let errorMessage = 'An unknown error occurred';
    let duration = 5000;
    if (error instanceof HttpResponse) {
      errorMessage = error['message'] || `Server returned ${error.status}: ${error.statusText}`;
      if (error.status === 401) {
        errorMessage = 'Session expired. Please login again.';
      } else if (error.status === 404) {
        errorMessage = 'Requested resource not found';
        duration = 3000;
      } else if (error.status >= 500) {
        errorMessage = 'Server error. Please try again later.';
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    console.error('API Error:', error);
    this._snackBar.open(errorMessage, 'OK', { duration, panelClass: ['error-snackbar'] });
    this.cdr.markForCheck();
  }

  openFeedbackDetail(event: Event, eLibraryId: LibraryItem): void {
    event.preventDefault();
    event.stopPropagation();

    const url = this.router.serializeUrl(this.router.createUrlTree([`/detail/${eLibraryId._id}`]));
    window.open(url, '_blank', 'noopener');
  }
}

